var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDevice16({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7323 2H7.26766C7.11984 2 7 2.12509 7 2.27939V22.7206C7 22.8749 7.11984 23 7.26766 23H15.7323C15.8802 23 16 22.8749 16 22.7206V2.27939C16 2.12509 15.8802 2 15.7323 2Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8285 2.40709V22.5932C15.8285 22.7188 15.7306 22.821 15.6102 22.821H7.39C7.26964 22.821 7.17177 22.7188 7.17177 22.5932V2.40709C7.17177 2.28145 7.26964 2.1793 7.39 2.1793H15.6102C15.7306 2.1793 15.8285 2.28145 15.8285 2.40709Z",
    fill: "#444444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3621 7.16242H7.6379C7.59067 7.16242 7.55238 7.20238 7.55238 7.25168V22.3847C7.55238 22.434 7.59067 22.474 7.6379 22.474H15.3621C15.4093 22.474 15.4476 22.434 15.4476 22.3847V7.25168C15.4476 7.20238 15.4093 7.16242 15.3621 7.16242Z",
    fill: "#252525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.962 8.06199H8.03779C8.01226 8.06199 7.99157 8.08359 7.99157 8.11023V20.7556C7.99157 20.7822 8.01226 20.8038 8.03779 20.8038H14.962C14.9875 20.8038 15.0082 20.7822 15.0082 20.7556V8.11023C15.0082 8.08359 14.9875 8.06199 14.962 8.06199Z",
    fill: "#030712"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37416 2.1793L9.516 5.98913C9.66132 6.47387 10.0916 6.80408 10.5783 6.80408H12.4215C12.9081 6.80408 13.3384 6.47413 13.4838 5.98913L14.6258 2.1793H8.37416Z",
    fill: "#3A3A3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52415 2.1793L9.84965 5.92025C9.8845 6.3214 10.2068 6.62866 10.5928 6.62866H12.4074C12.7932 6.62866 13.1155 6.3214 13.1506 5.92025L13.4761 2.1793H9.52415Z",
    fill: "#444444"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0827 2.1793H12.917V5.8266C12.917 5.88619 12.8706 5.93469 12.8135 5.93469H10.1863C10.1292 5.93469 10.0827 5.88619 10.0827 5.8266V2.1793Z",
    fill: "#343736"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5604 2.52602H10.4394C10.4123 2.52602 10.3904 2.54889 10.3904 2.5771V5.33438C10.3904 5.36259 10.4123 5.38546 10.4394 5.38546H12.5604C12.5874 5.38546 12.6093 5.36259 12.6093 5.33438V2.5771C12.6093 2.54889 12.5874 2.52602 12.5604 2.52602Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDevice16);
export default __webpack_public_path__ + "static/media/ic-device-16.3af9316cb07bf9d2a234499325e64471.svg";
export { ForwardRef as ReactComponent };